import { getToken } from "helpers/utilities";

const configuration = () => {
  const token = getToken()
   const config = {
     headers: { Authorization: `Bearer ${token}` },
   };
   return config;
 };


export default configuration;